/**
 * @module
 * @name Loader
 * @description Spinner, loader
 */
export default {
  name: 'Loader',

  /**
   * @function
   * @name mounted
   * @descrription Set overflow of body to hidden, to avoid scroll
   */
  mounted: function () {
    document.querySelector('body').style.overflow = 'hidden'
  },

  /**
   * @function
   * @name beforeDestroy
   * @descrription Set overflow of body to auto, to enable scroll if it's
   *               possible.
   */
  beforeDestroy: function () {
    document.querySelector('body').style.overflow = 'auto'
  }
}
